{
  "viewInContext": "View in context",
  "copyToClipboard": "Copy to clipboard",
  "copied": "Copied!",
  "copyFormattedLine": "Copy formatted line",
  "copyRawLine": "Copy raw line",
  "copyLineAsJson": "Copy line context as JSON",
  "shareThisLine": "Share this line",
  "extractFields": "Extract fields",
  "retentionPeriod": "{{count}} day retention",
  "kubeContext": {
    "kube": "Kube",
    "pod": "Pod",
    "node": "Node",
    "stats": "Stats",
    "notConfigured": "Kubernetes Statistics are not collected on this host's cluster. <a href=\"https://docs.$t(common:defaultHost)/docs/kubernetes-enrichment\" class=\"ml-1\" target=\"_blank\" title=\"Kubernetes Enrichment\">Learn more</a>.",
    "timedout": "Request timed out.  Unable to load Kubernetes Statistics.",
    "retry": "Try Again?",
    "deployed": "Deployed:",
    "podCreated": "Pod Created",
    "uptime": "Uptime:",
    "containerStarted": "Container Started",
    "usage": "Usage",
    "requests": "Requests",
    "limits": "Limits",
    "restarts": "Restarts:",
    "allocatable": "Allocatable",
    "capacity": "Capacity",
    "for": "for",
    "nodeCreated": "Node Created",
    "heartbeat": "Heartbeat:",
    "lastHeartbeat": "Last Heartbeat"
  }
}
